import { render, staticRenderFns } from "./shareIt.vue?vue&type=template&id=3a18be34&scoped=true&"
import script from "./shareIt.vue?vue&type=script&lang=js&"
export * from "./shareIt.vue?vue&type=script&lang=js&"
import style0 from "./shareIt.vue?vue&type=style&index=0&id=3a18be34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18be34",
  null
  
)

export default component.exports